import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import ServerStatsPage from "../components/ServerStatsPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		rank: state.data.userInfo.rank,
		firm: state.data.userInfo.firm,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const ServerStatsPageContainer = connect(mapStateToProps, mapDispatchToProps)(ServerStatsPage);

export default ServerStatsPageContainer;


// WEBPACK FOOTER //
// ./src/containers/ServerStatsPageContainer.js